import RootHub from "./root-hubs";
import useSignalRClient from "./signalr-hubs";
import { useDispatch } from "react-redux";
import {
  setRequestToState,
  unsetRequestFromState,
} from "@/store/slices/requests";
import Convo_signalr from "@/modules/crm/leads/convo-signalr-contants";
import { useRouter } from "next/router";
import { getCookie } from "../generic.methods";
import PublicHub from "./public-hubs";

const {
  InvokeMethodNames: { startConvo, sendMessage },
} = Convo_signalr;


// list of listeners that are no needed to subscribed initially
const NotToSubscribedMethods = [startConvo, sendMessage];

const OnInitHub = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const isCrm = router.asPath.split('/')?.[1] == 'crm'
  let hubNames = []
  let MainHub = []
  const auth = getCookie("CRM-Auth");

  if(isCrm && auth) {
    hubNames = RootHub.map((hub) => hub.hubName);
    MainHub = RootHub
  } else {
    hubNames = PublicHub.map((hub) => hub.hubName);
    MainHub = PublicHub
  }
  const { statuses, RTC } = useSignalRClient({ hubName: hubNames });

  const initOnReceiveMethods = () => {
    console.log("onReceiveMethods");
    getResponseMethods();
  };

  const getResponseMethods = () => {
    MainHub.map((hub) => {
      for (let key in hub.onReceiveMethodNames) {
        let methodName = hub.onReceiveMethodNames[key];
        if (methodName && !NotToSubscribedMethods.includes(methodName)) {
          // console.log("hub::", hub.hubName, "method ::", methodName);
          onReceive(hub.hubName, methodName);
        }
      }
    });
  };

  const onReceive = (hubName, methodName) => {
    let hub = RTC[hubName];
    let methodNameLower = methodName.toLowerCase();
    let activeListners = Object.keys(hub?._methods || {});
    // console.log(activeListners,"active listners");
    if (hub && !activeListners.includes(methodNameLower)) {
      hub.on(methodName, (response) => {
        console.log(`${methodName} response::`, response);
        // do some work here
        let payload = { key: methodName, data: response };
        dispatch(setRequestToState(payload));
      });
    }
  };

  const clearStateByMethods = (methodNames = []) => {
    dispatch(unsetRequestFromState({ keys: methodNames }));
  };

  return { initHub: initOnReceiveMethods, clearStateByMethods };
};

export default OnInitHub;
